import React from 'react';

interface TwitterIconProps {
    className?: string;
}

// Safari/iOS no dimensiona bien un <svg> inline que solo tiene viewBox (sin width/height
// explicitos ni display), y lo termina renderizando con tamaño 0. Por eso se declaran
// width/height, display:block y preserveAspectRatio, igual que hace MUI con sus SvgIcon.
const TwitterIcon: React.FC<TwitterIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            viewBox="0 0 1668.56 1221.19"
            width="1em"
            height="1em"
            preserveAspectRatio="xMidYMid meet"
            style={{ display: 'block', fontSize: '1.5rem', fill: '#fff', overflow: 'visible' }}
            focusable="false"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="translate(52.390088,-25.058597)">
                <path d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
          h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z" fill="#fff" />
            </g>
        </svg>
    );
};

export default TwitterIcon;
